import { Create } from 'react-admin'

import CampaignForm from './CampaignForm'

const CampaignCreate = props => {
  return (
    <Create undoable={false} {...props}>
      <CampaignForm isCreating permissions={props.permissions} />
    </Create>
  )
}

export default CampaignCreate
